import { Observable } from 'rxjs';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NbDialogRef, NbCardModule, NbButtonModule } from '@nebular/theme';

import { KPI } from '../../../@core/api';
import { InvestmentScenariiService } from '../../../@core/utils';
import { NavigationStart, Router } from '@angular/router';
import { filter, first } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridScenariiComponent } from '../ag-grid-scenarii/ag-grid-scenarii.component';

@Component({
    selector: 'app-scenario-management-dialog',
    templateUrl: './scenario-management-dialog.component.html',
    styleUrls: ['./scenario-management-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NbCardModule,
        AgGridScenariiComponent,
        TranslateModule,
        NbButtonModule
    ],
})
export class ScenarioManagementDialogComponent implements OnInit {

  public scenarii$: Observable<KPI.InvestmentScenario[]> = this.investmentScenariiService.scenarii$;

  constructor(
    private ref: NbDialogRef<ScenarioManagementDialogComponent>,
    private investmentScenariiService: InvestmentScenariiService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      first(),
    ).subscribe(() => this.close())
  }

  public close(): void {
    this.ref.close();
  }

}
